function addMoreRefClickHandler() {
    $(".load-more-references > a").click(function (ev) {
        ev.preventDefault();
        loadMoreReferences(this);
    });
}

function loadMoreReferences(link) {
    let $parent = $(link).closest(".load-more-references");
    let $container = $parent.parent();
    let $referenceList = $container.closest(".reference-list");
    let url = $parent.data("url") + "&cat=" + $referenceList.data("categories") + "&begin=" + $referenceList.children().length
        + "&_=" + new Date().getTime();
    $.get(url, function (data) {
        $container.remove();
        $referenceList.append(data);
        addMoreRefClickHandler();
        initMoreVideos();
    })
        .fail(function () {
            $container.remove();
            $referenceList.append("<p>Error retrieving data.</p>");
        });
}

function initReferences() {
    let $refCategorylink = $('.reference-category');
    let $refResultContainer = $('.reference-list');
    if ($refResultContainer.length) {
        if ($refCategorylink.length) {
            $refCategorylink.click(function (ev) {
                ev.preventDefault();
                let cat = $(this).data("category");
                let $listItem = $(this).closest("li")
                let $list = $(this).closest(".nav");
                let active = $listItem.hasClass("active");
                if (active) {
                    cat = $list.data("categories");
                }
                $refResultContainer.addClass("reference-list-hidden");
                $refResultContainer.load(this.href + "&begin=1&cat=" + cat + "&_=" + new Date().getTime(), function (response, status, xhr) {
                    if (status == "error") {
                        let msg = "Error retrieving data: ";
                        $refResultContainer.html(msg + xhr.status + " " + xhr.statusText);
                    }
                    $refResultContainer.removeClass("reference-list-hidden");
                    addMoreRefClickHandler();
                    initMoreVideos();
                });
                $refResultContainer.data("categories", cat);
                $list.children("li.active").removeClass("active");
                if (!active) {
                    $(this).closest("li").addClass("active");
                }
            });
        }

        addMoreRefClickHandler();
    }
}